import {HTMLReactParserOptions, Element as ParserElement} from 'html-react-parser';
import {Fragment, useContext} from 'react';

import {ClientDynamicContent, LanguageSwitcher, NodeElement, SessionTextChatProps} from 'components';
import {DynamicComponentNames, FullScreenTextChatUnits as Units, FULL_SCREEN_TEXT_CHAT_TEMPLATE} from 'constants/client';
import {ClientContext} from 'context';
import {useClientSession} from 'hooks';
import {dynamicContentUtils, imageUtils} from 'utils';

import {PreSessionModeSwitcher} from '../PreSessionModeSwitcher';

import './styles.scss';

const {isMatchElement, renderDefaultNode} = dynamicContentUtils;
const getOptions = (props: any): HTMLReactParserOptions => {
    const {
        TextChatComponent, session, onSubmitMessage, onFileDownload, onChangeTextChatActivityState, image,
        localParticipant
    } = props;
    return {
        replace: (domNode: any) => {
            if (!domNode.attribs) {
                return null;
            }

            const node = domNode as ParserElement;

            if (isMatchElement(Units.Logo, node)) {
                return <NodeElement node={node}><img className='logo-img' src={image || imageUtils.getLogo()} alt='Logo' /></NodeElement>;
            }
            if (isMatchElement(Units.Language, node)) {
                return <NodeElement node={node}><LanguageSwitcher className='language-switcher' hidePlaceholder /></NodeElement>;
            }
            if (isMatchElement(Units.TextChat, node)) {
                return (
                    <Fragment>
                        <PreSessionModeSwitcher />
                        <NodeElement node={node}>
                            <TextChatComponent
                                session={session}
                                onSubmitMessage={onSubmitMessage}
                                onFileDownload={onFileDownload}
                                onChangeState={onChangeTextChatActivityState}
                            />
                        </NodeElement>
                    </Fragment>);
            }
            return renderDefaultNode(node, {role: localParticipant.role});
        }
    };
};

type Props = {
    TextChatComponent?: React.ComponentType<SessionTextChatProps>;
};

export const FullScreenTextChat: React.FC<Props> = ({TextChatComponent}: Props) => {
    const {session, image} = useClientSession();
    const {onSubmitMessage, onFileDownload, onChangeTextChatActivityState} = useContext(ClientContext);

    return (
        <ClientDynamicContent
            component={DynamicComponentNames.FullScreenTextChat}
            defaultTemplate={FULL_SCREEN_TEXT_CHAT_TEMPLATE}
            optionsProps={{TextChatComponent, session, image, onSubmitMessage, onFileDownload, onChangeTextChatActivityState}}
            optionsGetter={getOptions}
        />
    );
};
